// src/AdminLogs.js
import React, { useEffect, useState } from "react";
import { db } from "./firebase";
// এখানে getDocs সরিয়ে দিয়েছি কারণ এটি ব্যবহার হচ্ছে না
import { collection, query, orderBy, deleteDoc, doc, onSnapshot } from "firebase/firestore";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);

  // ১. ফায়ারবেস থেকে রিয়েল-টাইম লগ ডাটা আনা
  useEffect(() => {
    setLoading(true);
    const q = query(collection(db, "admin_logs"), orderBy("time", "desc"));

    // onSnapshot ব্যবহার করায় ডাটাবেজে নতুন লগ আসার সাথে সাথে অটো আপডেট হবে
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const logsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setLogs(logsData);
      setLoading(false);
    }, (error) => {
      console.error("Snapshot error:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // ২. নির্দিষ্ট একটি লগ ডিলিট করার ফাংশন
  const deleteLog = async (id) => {
    if (window.confirm("আপনি কি এই লগটি ডিলিট করতে চান?")) {
      try {
        await deleteDoc(doc(db, "admin_logs", id));
      } catch (err) {
        console.error("Delete failed", err);
        alert("ডিলিট করতে সমস্যা হয়েছে!");
      }
    }
  };

  // সার্চ ফিল্টারিং (খালি স্পেস হ্যান্ডেল করা হয়েছে)
  const filteredLogs = logs.filter((log) =>
    log.event?.toLowerCase().includes(searchText.toLowerCase().trim()) ||
    log.details?.toLowerCase().includes(searchText.toLowerCase().trim())
  );

  return (
    <div className="p-4 md:p-12 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
          <h1 className="text-3xl font-black text-gray-800 tracking-tight">
            System <span className="text-[#D70F64]">Admin Logs</span>
          </h1>
          <div className="bg-white px-6 py-2 rounded-full shadow-sm border-2 border-gray-100 font-black text-[#D70F64]">
            Total Logs: {filteredLogs.length}
          </div>
        </div>

        {/* সার্চ বার */}
        <div className="relative mb-8 group">
          <input
            type="text"
            placeholder="ইভেন্ট সার্চ করুন (যেমন: login, order)..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="w-full p-5 pl-14 rounded-[25px] border-2 border-transparent shadow-[0_10px_30px_rgba(0,0,0,0.05)] focus:border-[#D70F64] outline-none transition-all font-bold"
          />
          <span className="absolute left-6 top-5 text-xl group-focus-within:scale-110 transition-transform">🔍</span>
        </div>

        {/* লগের টেবিল */}
        <div className="bg-white rounded-[35px] shadow-[0_20px_60px_rgba(0,0,0,0.05)] overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-900 text-white">
                <tr>
                  <th className="p-6 font-black uppercase text-xs tracking-widest">Event</th>
                  <th className="p-6 font-black uppercase text-xs tracking-widest">Details</th>
                  <th className="p-6 font-black uppercase text-xs tracking-widest">Time</th>
                  <th className="p-6 font-black uppercase text-xs tracking-widest text-center">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {loading ? (
                  <tr>
                    <td colSpan="4" className="p-20 text-center">
                      <div className="flex flex-col items-center gap-2">
                        <div className="w-8 h-8 border-4 border-[#D70F64] border-t-transparent rounded-full animate-spin"></div>
                        <p className="text-gray-400 font-bold italic">Loading from Firebase...</p>
                      </div>
                    </td>
                  </tr>
                ) : filteredLogs.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="p-20 text-center text-gray-400 font-bold text-lg">
                      কোনো লগ পাওয়া যায়নি! 🗑️
                    </td>
                  </tr>
                ) : (
                  filteredLogs.map((log) => (
                    <tr key={log.id} className="hover:bg-gray-50/80 transition-colors group">
                      <td className="p-6">
                        <span className={`px-4 py-1.5 rounded-xl text-[10px] font-black uppercase tracking-wider ${
                          log.event === 'login' ? 'bg-blue-50 text-blue-600 border border-blue-100' : 
                          log.event === 'order' ? 'bg-green-50 text-green-600 border border-green-100' : 
                          'bg-gray-50 text-gray-500 border border-gray-100'
                        }`}>
                          {log.event}
                        </span>
                      </td>
                      <td className="p-6 text-gray-700 font-bold text-sm">
                        {log.details}
                      </td>
                      <td className="p-6 text-xs text-gray-400 font-medium">
                        {/* সময়টাকে সুন্দর করে দেখানোর জন্য */}
                        {log.time ? new Date(log.time).toLocaleString('en-GB', { 
                          day: '2-digit', month: 'short', year: 'numeric', 
                          hour: '2-digit', minute: '2-digit', hour12: true 
                        }) : 'N/A'}
                      </td>
                      <td className="p-6 text-center">
                        <button 
                          onClick={() => deleteLog(log.id)}
                          className="w-10 h-10 rounded-xl flex items-center justify-center text-gray-300 hover:text-red-500 hover:bg-red-50 transition-all active:scale-90"
                          title="Delete Log"
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}